import { Component, OnDestroy, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { filter, map, shareReplay, takeUntil } from 'rxjs/operators';

import { AnalyticsService } from '@digital-platform/analytics/services';
import { FeatureFlagsService } from '@digital-platform/shared/services';
import { LoginSession } from '@digital-platform/users/domain';
import { LoginSessionFacadeService } from '@digital-platform/users/services';
import { ContactDialogComponent } from '../contact-dialog/contact-dialog.component';

@Component({
  selector: 'digital-platform-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnDestroy {
  private destroyed$ = new Subject<void>();
  public loggedIn$: Observable<boolean>;
  public emailVerified$: Observable<boolean>;
  public isCustomer = false;
  public isSpecialist = false;
  public isContactUs = false;
  public universalLogin: boolean;

  @ViewChild('contactCustomerDialog', { static: false }) contactCustomerDialog;
  constructor(
    public dialog: MatDialog,
    private loginSessionFacade: LoginSessionFacadeService,
    private readonly analytics: AnalyticsService,
    private featureFlag: FeatureFlagsService,
    private router: Router
  ) {
    this.loggedIn$ = this.loginSessionFacade.loginSession$.pipe(
      map((loginSession) => {
        let loggedIn = true;
        if (loginSession === null || loginSession?.user === null) {
          loggedIn = false;
        } else if (loginSession?.user?.requirePasswordReset) {
          loggedIn = false;
        }
        return loggedIn;
      }),
      shareReplay(1)
    );

    this.emailVerified$ = this.loginSessionFacade.loginSession$.pipe(
      map((loginSession) => loginSession?.user?.emailVerified || false),
      shareReplay(1)
    );

    this.loginSessionFacade.loginSession$
      .pipe(
        takeUntil(this.destroyed$),
        filter((session) => session !== null)
      )
      .subscribe((loginSession: LoginSession) => {
        this.analytics.registerUserData(loginSession);
        this.isCustomer =
          loginSession?.user?.roles?.includes('Customer') || false;
        this.isSpecialist =
          loginSession?.user?.roles?.includes('Sales Support Specialist') ||
          false;
        this.isContactUs =
          loginSession?.user?.permissions?.includes('view:contact_us');
      });

    this.universalLogin = Boolean(
      this.featureFlag.getValue('isUniversalLogin')
    );
    this.initializeAppsBar();
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public openDialog(): void {
    this.dialog.open(ContactDialogComponent, {
      width: '650px',
      height: '400px',
    });
  }

  public onClickLogout() {
    this.loginSessionFacade.logout('Logout successful.');
  }

  public initializeAppsBar() {
    const appBar = document.querySelector('aura-app-bar');
    appBar?.addEventListener('logout', () => {
      this.loginSessionFacade.logout('Logout successful.');
    });
  }

  handleContactModal() {
    if (this.isContactUs) {
      this.router.navigate(['/contact']);
    } else {
      this.dialog.open(this.contactCustomerDialog, {
        width: '650px',
      });
    }
  }

  closeAll() {
    this.dialog?.closeAll();
  }
}
